import { all, fork } from 'redux-saga/effects';
import auth from './auth';
import interfaceComponents from './interface';
import scenario from './scenario';
import jobs from './jobs';
import trade from './trade';
import account from './account';
import transfer from './transfer';
import maintenance from './maintenance';

export default function* rootSaga() {
  return yield all(
    [auth, interfaceComponents, scenario, jobs, trade, account, transfer, maintenance].map(fork)
  );
}
